import { connect } from 'react-redux';
import { OPERATIONS } from '../../constants';
import BookingValidationGeonealogy from './BookingValidationGeonealogy';
import BookingValidationStages from './BookingValidationStages';

const mapStateToProps = (state) => {
  return {
    allowedOperations: state.operations.allowedOperations,
  };
};

const BookingValidationContainer = ({ allowedOperations }) => {
  if (allowedOperations.includes(OPERATIONS.BOOK))
    // return <BookingValidationGeonealogy />;
  return <BookingValidationStages/>;
};

export default connect(mapStateToProps)(BookingValidationContainer);
